import React, { useState, useEffect, useContext } from "react";
import {
  TroubleShootingStudyErrorColumns,
  auditInitialState,
  breadCrumbItems,
  calendarStyle,
  errorStudyInitialState,
  searchStyle,
  tabDetails,
} from "./helper/helper";
import loaderContext from "../../context/loader/LoaderContext";
import { t } from "i18next";
import {
  Calendar,
  PrimaryButton,
  SearchBox,
  TextField,
  TooltipHost,
  defaultCalendarStrings,
} from "@fluentui/react";
import Moment from "moment";
import { getErrorCodeList, getStudyErrorSearchList } from "../../service/MasterService";
import userContext from "../../context/users/UserContext";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import { errorListCSVService } from "../../service/AuditLogService";
import { TOAST_TYPE } from "../../constants/Constants";
import toastContext from "../../context/toast/ToastContext";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";

const ErrorStudyListView = (props) => {
  const {  errorStudyFilterObj,setErrorStudyFilterObj,displayListAppliedFilter,setDisplayListAppliedFilter,filterObj,setFilterObj} = props;
  const [selectedRow, setSelectedRow] = useState(0);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const { showToastv2 } =
  useContext(toastContext);
  const [activeDataQuery,setActiveDataQuery] = useState([]); 
  const [dataQueryState, setDataQueryState] = useState({}); 

  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });
  const [errorList, setErrorList] = useState([]);
 

  const formatDate = (date) => {
    return Moment(date).format('DD-MMM-YYYY');
}

  const fetchData = async (options) => {
    // let page = options.pageIndex;
    // let pageSize = options.pageSize;
    console.log("--- Fetching Data Error List ----");
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const payload = {
      errorDateFrom: errorStudyFilterObj.dateFrom == null? null : formatDate(errorStudyFilterObj.dateFrom),
      errorDateTo: errorStudyFilterObj.dateTo == null ? null : formatDate(errorStudyFilterObj.dateTo),
      studyErrorListsPage: options.page,
      pageSize:50
    };

    
    try {

      setLoaderRunning(true);
      ref.current.continuousStart();


      let data = null;
      let pageCount = null;

      const response = await getStudyErrorSearchList( payload );
      
      
      if (response.status === 200 && response.data.result === "SUCCESS") {
        console.log("--- Error list response ----",response);
       
        let results = response.data.data.result.searchResults;
        setErrorList(results);
        const pageSize = response.data.data.result.pageSize;
        const totalElement = response.data.data.result.totalRecords;
        data = results;
        pageCount = Math.ceil(totalElement / pageSize);
        console.log("--- Sending Data ---",data,pageCount);

        setLoaderRunning(false);
        ref.current.complete();

        return {
          rows: data,
          pageCount: pageCount,
        };
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const handleUserClick = (cell) => {
    console.log("--- This row clicked ----", cell);
    let row = cell.row;
    setSelectedRow(row.index);
  };

  const filterList = (searchInput) => {
    console.log("--- Filter function TODO ---");
  };

  const handleClearFilter = () => {
    console.log("---- Clear Filter Clicked ----");
    setErrorStudyFilterObj(errorStudyInitialState(null))
    setDisplayListAppliedFilter([]);
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = null;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const columns = TroubleShootingStudyErrorColumns(null);


  const removeBadgeFromFilter = (toBeRemoveObj) => {
    console.log("--- Updating RemoveBadgeFromFilter ----", toBeRemoveObj);
    setErrorStudyFilterObj((currentAuditFilterObj) => {
      const updatedAuditFilterObj = { ...currentAuditFilterObj };

      if (updatedAuditFilterObj.hasOwnProperty(toBeRemoveObj.key)) {
        updatedAuditFilterObj[toBeRemoveObj.key] = null;
      } else {
        console.error(
          `Key "${toBeRemoveObj.key}" does not exist in auditInitialState.`
        );
      }
      return updatedAuditFilterObj;
    });

    setDisplayListAppliedFilter((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  useEffect(() => {
    setSelectedRow(0);
  }, [paginationObj]);

  const getLabelForDate = (label,date) => {
    if(date == null)return null;
    else{
      if(label == "dateFrom"){
        return "From: "+date;
      }else{
        return "To: "+date;
      }
    }
  }

  const handleApplyClick = () => {
    const transformedArray = Object.keys(errorStudyFilterObj)
      .map((key) => ({ key, label: getLabelForDate(key,errorStudyFilterObj[key]) }))
      .filter((item) => item.label !== null);
    console.log("--- Handle Apply Click ---",errorStudyFilterObj, transformedArray);

    setDisplayListAppliedFilter(transformedArray);

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  useEffect(()=>{
    console.log("Active Query",activeDataQuery)
    if(activeDataQuery != undefined && activeDataQuery.data != undefined){
      setErrorList(activeDataQuery?.data?.rows);
    }
  },[activeDataQuery]);

  const downloadErrorList = async() => {

    const payload = {
      errorListsSearchDto: {
        errorDateFrom: errorStudyFilterObj.dateFrom == null? null : formatDate(errorStudyFilterObj.dateFrom),
        errorDateTo: errorStudyFilterObj.dateTo == null ? null : formatDate(errorStudyFilterObj.dateTo),
        studyErrorListsPage: paginationObj.pageIndex,
        pageSize:50
      }
      
    };

      try{

        setLoaderRunning(true);
        ref.current.continuousStart();
        console.log("--- Error list download started ----");
        const response = await errorListCSVService(payload);
        
          if (response.status === 200 && response.data.result === "SUCCESS") {
            setLoaderRunning(false);
            showToastv2(TOAST_TYPE.SUCCESS, t("audit-logs.success-message"));
          }else{
            setLoaderRunning(false);
            showToastv2(TOAST_TYPE.ERROR,t("audit-logs.failure-message"));
          }
      }catch(e){
        setLoaderRunning(false);
        showToastv2(TOAST_TYPE.ERROR,t("audit-logs.failure-message"));
      }
}

  const buttonsTopBar = [{
    key: "1",
    button: 
      <div className="add-button-list-view" onClick={()=>{downloadErrorList()}}>
        {/* <AddButton  text={t("supervisor.add-supervisor")} /> */}
        <PrimaryButton
          text={t("button.export-csv")}
          className={"common-default-active-button list-view-top-buttons-styles"}
          disabled={activeDataQuery?.data?.rows?.length > 0 ? false : true}
        />
      </div>
  },
  ];


  return (
    <>
      <ListViewV3
        buttonsTopBar={buttonsTopBar}
        sortDropdownOptions={[]}
        fetchData={fetchData}
        columns={columns}
        handleUserClick={handleUserClick}
        setActiveDataQuery={setActiveDataQuery}
        setDataQueryState={setDataQueryState}
        dataQueryState={dataQueryState}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        sortObj={sortObj}
        setSortObj={setSortObj}
        setPagination={setPagination}
        paginationObj={paginationObj}
        uniqueKey={"ErrorList"}
        selectedRow={selectedRow}
        showSideBySide={false}
        tabHeaderPresent={true}
        selectedRowComponent={<SelectedRowComponent
          errorList={errorList[selectedRow]}
          displayListAppliedFilter={displayListAppliedFilter}
        />}
        enhancedFilter={true}
        handleApplyClick={handleApplyClick}
        displayListAppliedFilter={displayListAppliedFilter}
        filterList={filterList}
        handleClearFilter={handleClearFilter}
        removeBadgeFromFilter={removeBadgeFromFilter}
        filterPopUpComponent={<FilterPopUpComponent
          errorStudyFilterObj={errorStudyFilterObj}
          setErrorStudyFilterObj={setErrorStudyFilterObj}
        />}
        showSearch={false}
        showSort={false}
        pointer={false}
        fullLength={true}
      />
    </>
  );
};

export default ErrorStudyListView;

const SelectedRowComponent = ({
  errorList,
  displayListAppliedFilter,
}) => {

  const {getConsistentDateFormat} = useContext(userContext);

  if (errorList == undefined) {
    return (
      displayListAppliedFilter.length === 0 && (
        <>
          <div className="list-view-no-details-found">
            <p className="study-list-no-data-txt"></p>
          </div>
        </>
      )
    );
  }

  const customToolTipErrDesc = {
    root:"error-discription-text"
  }

  return (
    <>
      <div className="tab-section">
        <section className="sectionA">
          <p
            style={{
              fontSize: "20px",
              fontWeight: "600",
              padding: "0px 8px",
              margin: "10px 0px",
            }}
          >
            {t("error-study-list.error-study-details")}
          </p>
        </section>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("error-study-list.patient-id")}</div>
              <div className="form-mt-10">{errorList.patientId}</div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">
                {t("error-study-list.error-code")}
              </div>
              <div className="form-mt-10">
                {errorList.hospitalCode}
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("error-study-list.object-path")}</div>
              <div className="form-mt-10">
                {errorList.objectName == ""
                  ? "-"
                  : errorList.objectName}
              </div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("error-study-list.description")}</div>
              <div className="form-mt-10">
                <CustomToolTipHost styles={customToolTipErrDesc} content={errorList.errorDescription} id="error-des">
                  {!errorList.errorDescription || errorList.errorDescription == ""
                  ? "-"
                  : errorList.errorDescription}</CustomToolTipHost>
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("error-study-list.action")}</div>
              <div className="form-mt-10">
                {errorList.actionBy == ""
                  ? "-"
                  : errorList.actionBy}
              </div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t("error-study-list.error-date")}</div>
              <div className="form-mt-10">
                {getConsistentDateFormat(errorList.createdDate)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FilterPopUpComponent = ({
  errorStudyFilterObj,
  setErrorStudyFilterObj,
}) => {


  const formattedDate = (date) => {
    return date
      .toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
  };

  return (
    <div style={{ display: "flex" }}>
      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: "15%" }}
      >
        <span className="filter-section-text" style={{display:'flex',justifyContent:'center'}}>
          {t("error-study-list.error-date-from")}
        </span>
        <div className="modal-scroll study-list-filter-section-without-search">
          <ul
            className="upload-date-ul"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {/* <DatePicker
                      className={calendarStyles.wrapper}
                      placeholder="dd/mm/yyyy"
                      //value={selectFromDate}
                      // onSelectDate={(data)=>{console.log(data)}
                      allowTextInput={true}
                      openOnClick={false}
                      isMonthPickerVisible={false}
                      isDatePickerVisible={false}
                      formatDate={(date) => date?.toLocaleDateString()}
                      parseDateFromString={parseDateFromString}
                      ariaLabel="Select a date"
                    /> */}
            <Calendar
              showMonthPickerAsOverlay={true}
              placeholder={t("placeholder.select-date")}
              ariaLabel="Select a date"
              // DatePicker uses English strings by default. For localized apps, you must override this prop.
              styles={calendarStyle}
              showGoToToday={false}
              strings={defaultCalendarStrings}
              onSelectDate={(date) =>
                setErrorStudyFilterObj({
                  ...errorStudyFilterObj,
                  dateFrom: formattedDate(date),
                })
              }
            />
          </ul>
        </div>
      </div>

      <div className="filter-section-seperator"></div>
      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: "15%" }}
      >
        <span className="filter-section-text" style={{display:'flex',justifyContent:'center'}}>{t("error-study-list.error-date-to")}</span>
        <div className="modal-scroll study-list-filter-section-without-search">
          <ul
            className="upload-date-ul"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Calendar
              showMonthPickerAsOverlay={true}
              placeholder={t("placeholder.select-date")}
              ariaLabel="Select a date"
              // DatePicker uses English strings by default. For localized apps, you must override this prop.
              styles={calendarStyle}
              showGoToToday={false}
              //strings={defaultCalendarStrings}
              onSelectDate={(date) =>
                setErrorStudyFilterObj({
                  ...errorStudyFilterObj,
                  dateTo: formattedDate(date),
                })
              }
            />
          </ul>
        </div>
      </div>
    </div>
  );
};
